'use strict';

function CompanyPublicationFilePreviewDirective(
  CompanyPublicationFileService,
  PublicationCollabrationService,
  $interval) {
  return {
    scope: {
      filePreview: '=',
      isCollabration: '='
    },
    restrict: 'A',
    require: "ngModel",
    link: function($scope, elem, attrs, model) {
      model.$render = function() {
        $scope.file = model.$viewValue;
        previewHandler();
      };
      $scope.$watch("file", function(newData, oldData) {
        if(angular.equals(newData, oldData) || angular.equals(newData, model.$viewValue)) {
          return;
        }
        model.$setViewValue(newData);
        model.$render();
      }, true);

      var getPreview = function() {
        if ($scope.isCollabration) {
          PublicationCollabrationService.getPreview({
            publicationId: $scope.filePreview.publicationId,
            fileId: $scope.file.id
          }, function(data) {
            elem.attr('src', 'data:' + data.dataUrl);
          });
        } else {
          CompanyPublicationFileService.getPreview({
            companyId: $scope.filePreview.companyId,
            publicationId: $scope.filePreview.publicationId,
            fileId: $scope.file.id
          }, function(data) {
            elem.attr('src', 'data:' + data.dataUrl);
          });
        }
      };

      var previewHandler = function() {
        if ($scope.file.previewStatus === 'PROCESSED') {
          getPreview();
        } else {
          if ($scope.file.previewStatus === 'QUEUED') {
            var intervalPromise = $interval(function(){
              CompanyPublicationFileService.get({
                companyId: $scope.filePreview.companyId,
                publicationId: $scope.filePreview.publicationId,
                fileId: $scope.file.id
              }, function(data){
                $scope.file = data;
                if ($scope.file.previewStatus !== 'QUEUED') {
                  $interval.cancel(intervalPromise);
                }
              });
            }, 2000, 5);
          }
        }
      };

      $scope.$on('fileProcessed', function(e, data){
        $scope.file = data;
      });
    }
  };
}

angular.module('dokiv')
  .directive('filePreview', [
    'CompanyPublicationFileService',
    'PublicationCollabrationService',
    '$interval', CompanyPublicationFilePreviewDirective]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationFilePreviewDirective.js
// module id = 377
// module chunks = 0